import _ from 'lodash';

import { removePartialIntervalsDates } from 'removePartialIntervals';
import toAutoInterval from 'components/V5Gadget/toAutoInterval';

const getRangeBuckets = ({
  isTwoDimensional,
  chartDef,
  responses,
}: {
  isTwoDimensional: boolean;
  chartDef: V5ChartDefinition;
  responses: MetricsResponse[];
}): string[] => {
  if (!isTwoDimensional) {
    return [];
  }

  let autoInterval = undefined as AutoInterval | undefined;
  let dateScope = undefined as DateRangeInput | undefined;
  const buckets = [] as string[];

  responses[0].forEach((r) => {
    if (chartDef.dimensionB && chartDef.dimensionB.rangeInput) {
      // @ts-ignore
      r.values.forEach((v) => {
        buckets.push(v.key);
      });
    }

    if (chartDef.dimensionB && chartDef.dimensionB.fieldType === 'date') {
      dateScope = r['dateScope'] as DateRangeInput | undefined;
      // @ts-ignore
      r.values.forEach((v) => {
        buckets.push(v.date);
        if (v['interval']) {
          autoInterval = toAutoInterval(v['interval']);
        }
      });
    }
  });

  const uniqDates = _.uniq(buckets) as string[];

  if (chartDef.excludePartialIntervals) {
    const datesToUse = removePartialIntervalsDates(
      uniqDates,
      autoInterval ? autoInterval.interval : undefined,
      dateScope,
    );
    return datesToUse.sort();
  } else {
    return uniqDates.sort();
  }
};

export default getRangeBuckets;
